import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import UI_BASE_PATH from "./base-path";

const ConnectedApp = () => (
  <BrowserRouter basename={UI_BASE_PATH}>
    <App />
  </BrowserRouter>
);

ReactDOM.render(<ConnectedApp />, document.getElementById("root"));

const preload = document.getElementById("preload");
if (preload.remove) {
  preload.remove();
} else {
  document.body.removeChild(preload);
}
